<template>
  <div class="supervisor-element-info">
    <!-- Información de Ruta -->
    <div v-if="type === 'route'" class="route-info">
      <v-card-subtitle class="px-0">
        <v-icon color="primary">mdi-map-marker-path</v-icon>
        Información de Ruta
      </v-card-subtitle>
      
      <v-list dense>
        <v-list-item>
          
            <v-list-item-title>{{ data.name }}</v-list-item-title>
            <v-list-item-subtitle>Ruta Principal</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-group</v-icon>
          </template>
          
            <v-list-item-title>Grupo {{ data.groupId }}</v-list-item-title>
            <v-list-item-subtitle>Grupo asignado</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-store-multiple</v-icon>
          </template>
          
            <v-list-item-title>{{ data.agencies?.length || 0 }} Agencias</v-list-item-title>
            <v-list-item-subtitle>En esta ruta</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-map-marker-distance</v-icon>
          </template>
          
            <v-list-item-title>{{ data.distance || 'N/A' }} km</v-list-item-title>
            <v-list-item-subtitle>Distancia total</v-list-item-subtitle>
          
        </v-list-item>
      </v-list>
      
      <v-divider class="my-3" />
      
      <div class="d-flex justify-center gap-2">
        <v-tooltip text="Ver Detalles" location="bottom">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              color="primary"
              variant="outlined"
              size="small"
              icon
              @click="viewRouteDetails"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
        
      </div>
    </div>

    <!-- Información de Incidencia -->
    <div v-else-if="type === 'incident'" class="incident-info">
      <v-card-subtitle class="px-0">
        <v-icon color="orange">mdi-alert</v-icon>
        Información de Incidencia
      </v-card-subtitle>
      
      <v-list dense>
        <v-list-item>
          
            <v-list-item-title>{{ data.title }}</v-list-item-title>
            <v-list-item-subtitle>{{ data.description }}</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-flag</v-icon>
          </template>
          
            <v-list-item-title>
              <v-chip 
                :color="getPriorityColor(data.priority)"
                size="small"
              >
                {{ data.priority || 'Medium' }}
              </v-chip>
            </v-list-item-title>
            <v-list-item-subtitle>Prioridad</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-progress-clock</v-icon>
          </template>
          
            <v-list-item-title>
              <v-chip 
                :color="getStatusColor(data.status)"
                size="small"
              >
                {{ data.status }}
              </v-chip>
            </v-list-item-title>
            <v-list-item-subtitle>Estado actual</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-calendar</v-icon>
          </template>
          
            <v-list-item-title>{{ formatDate(data.createdAt) }}</v-list-item-title>
            <v-list-item-subtitle>Fecha de reporte</v-list-item-subtitle>
          
        </v-list-item>
      </v-list>
      
      <v-divider class="my-3" />
      
      <div class="d-flex justify-center gap-2">
        <v-tooltip text="Ver Detalles" location="bottom">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              color="primary"
              variant="outlined"
              size="small"
              icon
              @click="viewIncidentDetails"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
        
      </div>
    </div>

    <!-- Información de POS -->
    <div v-else-if="type === 'pos'" class="pos-info">
      <v-card-subtitle class="px-0">
        <v-icon color="green">mdi-store</v-icon>
        Punto de Venta
      </v-card-subtitle>
      
      <v-list dense>
        <v-list-item>
          
            <v-list-item-title>{{ data.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ data.code }}</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-map-marker</v-icon>
          </template>
          
            <v-list-item-title>{{ data.address }}</v-list-item-title>
            <v-list-item-subtitle>Dirección</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-progress-check</v-icon>
          </template>
          
            <v-list-item-title>
              <v-chip 
                :color="getPOSStatusColor(data.status)"
                size="small"
              >
                {{ data.status || 'Active' }}
              </v-chip>
            </v-list-item-title>
            <v-list-item-subtitle>Estado operativo</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-calendar-check</v-icon>
          </template>
          
            <v-list-item-title>{{ data.lastVisit || 'Pendiente' }}</v-list-item-title>
            <v-list-item-subtitle>Última visita</v-list-item-subtitle>
          
        </v-list-item>
      </v-list>
      
      <v-divider class="my-3" />
      
      <div class="d-flex justify-center gap-2">
        <v-tooltip text="Ver Detalles" location="bottom">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              color="primary"
              variant="outlined"
              size="small"
              icon
              @click="viewPOSDetails"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
        
      </div>
    </div>

    <!-- Información de Supervisión -->
    <div v-else-if="type === 'supervision'" class="supervision-info">
      <v-card-subtitle class="px-0">
        <v-icon color="purple">mdi-eye</v-icon>
        Supervisión
      </v-card-subtitle>
      
      <v-list dense>
        <v-list-item>
          
            <v-list-item-title>Supervisión #{{ data.id }}</v-list-item-title>
            <v-list-item-subtitle>{{ data.type || 'Rutinaria' }}</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-calendar</v-icon>
          </template>
          
            <v-list-item-title>{{ formatDate(data.date) }}</v-list-item-title>
            <v-list-item-subtitle>Fecha programada</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-progress-clock</v-icon>
          </template>
          
            <v-list-item-title>
              <v-chip 
                :color="getSupervisionStatusColor(data.status)"
                size="small"
              >
                {{ data.status }}
              </v-chip>
            </v-list-item-title>
            <v-list-item-subtitle>Estado</v-list-item-subtitle>
          
        </v-list-item>
        
        <v-list-item v-if="data.notes">
          <template #prepend>
            <v-icon>mdi-note-text</v-icon>
          </template>
          
            <v-list-item-title>{{ data.notes }}</v-list-item-title>
            <v-list-item-subtitle>Observaciones</v-list-item-subtitle>
          
        </v-list-item>
      </v-list>
      
      <v-divider class="my-3" />
      
      <div class="d-flex justify-center gap-2">
        <v-tooltip text="Ver Detalles" location="bottom">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              color="primary"
              variant="outlined"
              size="small"
              icon
              @click="viewSupervisionDetails"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
        
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Props
interface Props {
  type: string
  data: any
  supervisorId?: number
}

const props = defineProps<Props>()

// Métodos de colores
const getPriorityColor = (priority: string): string => {
  const colors = {
    high: 'red',
    medium: 'orange',
    low: 'green'
  }
  return colors[priority] || 'orange'
}

const getStatusColor = (status: string): string => {
  const colors = {
    open: 'red',
    in_progress: 'blue',
    resolved: 'green',
    closed: 'grey'
  }
  return colors[status] || 'grey'
}

const getPOSStatusColor = (status: string): string => {
  const colors = {
    active: 'green',
    inactive: 'grey',
    maintenance: 'orange',
    suspended: 'red'
  }
  return colors[status] || 'green'
}

const getSupervisionStatusColor = (status: string): string => {
  const colors = {
    scheduled: 'blue',
    in_progress: 'orange',
    completed: 'green',
    cancelled: 'grey'
  }
  return colors[status] || 'blue'
}

// Métodos de formato
const formatDate = (date: string): string => {
  if (!date) return 'N/A'
  return new Date(date).toLocaleDateString('es-DO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

// Métodos de acción
const viewRouteDetails = () => {
  console.log('Ver detalles de ruta:', props.data)
  // Implementar navegación o modal
}

const viewIncidentDetails = () => {
  console.log('Ver detalles de incidencia:', props.data)
  // Implementar navegación o modal
}

const viewPOSDetails = () => {
  console.log('Ver detalles de POS:', props.data)
  // Implementar navegación o modal
}


const viewSupervisionDetails = () => {
  console.log('Ver detalles de supervisión:', props.data)
  // Implementar navegación o modal
}

</script>

<style scoped>
.supervisor-element-info {
  width: 100%;
}

.gap-2 > * {
  margin-bottom: 8px;
}

.v-list-item {
  min-height: 40px;
}

.v-list-item-subtitle {
  opacity: 0.7;
  font-size: 0.875rem;
}
</style>
